const authentication = require('../../../react-azure-adb2c2').default;
export const list = (values: any) => {


    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    // let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/owner/remittance/check/log`;
    // let url = `https://192.168.0.207/fuelphp-1.8/public/money/rest/bklist.json`
     let url = 'https://go.homestation.jp/bklist';
      // let url = 'https://go.homsetation.jp/bklist.json';
      // let url = 'https://hskaku.homestation.jp/manage/money/rest/bklist.json';
    // let url = `http://localhost:5000/api/v1/owner/remittance/check/logs`;
  const token = authentication.getAccessToken();
    return fetch(url, {
        method: 'get',
      credentials: 'include', // ← セッションCookieを確実に送る
      headers: {
        'Accept': 'application/json',

      'Authorization': 'Bearer ' + token
 
        // 'X-Requested-With': 'XMLHttpRequest', // ← ログインページHTMLを返さずJSONエラーにしてもらうため
        // CSRFが必要な場合は↓を併用（例）
        // 'X-CSRF-Token': getCsrfToken(),
      },

        // headers: { 'Content-type': 'application/json; charset=UTF-8' }
        // body: JSON.stringify(values),
        // headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));




}

